export enum DesignFileType {
  BMP = '.bmp',
  EP = '.ep',
  TFT = '.tft',
  PVD = '.pvd'
}
